import React, { useMemo, useState } from "react";
import { IoDocumentTextOutline } from "react-icons/io5";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { LuPencil } from "react-icons/lu";
import { IoBan } from "react-icons/io5";
import { GoTrash } from "react-icons/go";
import { MdClose } from "react-icons/md";
import HeaderFilter from "../../Dashboard/DashboardTable/HeaderFilter";
import Pagination from "./Pagination";
import { IoAdd } from "react-icons/io5";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import DeleteVec from "../../../../../Assets/Images/deleteVec.png";
import UnBlockVec from "../../../../../Assets/Images/unblockVec.png";
import { LiaUserLockSolid } from "react-icons/lia";
import { allCountries } from "country-telephone-data";
import { postApiCaller } from "../../../../../Libs/apiCaller";
import { toast } from "react-toastify";
import profile_Img from "../../../../../Assets/Images/profile_Img.png";

export default function BlockedUsersList({
  setBlockedUsers,
  blockedUsers,
  getBlockedUsers,
  isAddUserModalOpen,
  closeAddUserModal,
  currentPage,
  totalPages,
  totalUsers,
  isLoading,
}) {
  const [sortConfig, setSortConfig] = useState({
    key: "name",
    direction: "asc",
  });
  const [isMenuOpen, setIsMenuOpen] = useState(null);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isBlockModalOpen, setIsBlockModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isUnblocking, setIsUnblocking] = useState(false);
  const [imagePreview, setImagePreview] = useState(null); // For image upload
  const [newUserDetails, setNewUserDetails] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
    gender: "",
    avatar: "",
  });

  const sortedData = useMemo(() => {
    return [...blockedUsers].sort((a, b) => {
      if (sortConfig.key === "countryCode") {
        return sortConfig.direction === "asc"
          ? a.countryCode.localeCompare(b.countryCode)
          : b.countryCode.localeCompare(a.countryCode);
      }
      if (sortConfig.key === "blockedBy") {
        return sortConfig.direction === "asc"
          ? a.blockedBy.name.localeCompare(b.blockedBy.name)
          : b.blockedBy.name.localeCompare(a.blockedBy.name);
      }
      if (a[sortConfig.key].toLowerCase() < b[sortConfig.key].toLowerCase())
        return sortConfig.direction === "asc" ? -1 : 1;
      if (a[sortConfig.key].toLowerCase() > b[sortConfig.key].toLowerCase())
        return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [sortConfig, blockedUsers]);

  const getCountryFromPhoneCode = (code) => {
    const phoneCode = code.replace("+", "");
    const match = allCountries.find((c) => c.dialCode === phoneCode);
    return match ? match.name : "Unknown";
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const toggleMenu = (index) => {
    setIsMenuOpen(isMenuOpen === index ? null : index);
  };

  const openModal = (type) => {
    if (type === "edit") {
      setIsEditModalOpen(true);
    } else if (type === "block") {
      setIsBlockModalOpen(true);
    } else if (type === "delete") {
      setIsDeleteModalOpen(true);
    }
  };

  const closeModal = (type) => {
    if (type === "edit") {
      setIsEditModalOpen(false);
    } else if (type === "block") {
      setIsBlockModalOpen(false);
    } else if (type === "delete") {
      setIsDeleteModalOpen(false);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleRemoveImage = () => {
    setImagePreview(null);
  };

  const handleNextClick = () => {
    // Handle next step logic if needed
  };

  const unblockUser = async () => {
    setIsUnblocking(true);
    if (!selectedUser) {
      setIsUnblocking(false);
      toast.error("Please select a user to unblock");
      return;
    }
    const res = await postApiCaller(`users/unblockByAdmin`, {
      blockedUserId: selectedUser._id,
      blockedById: selectedUser.blockedBy.id,
    });
    if (res.status === 200) {
      toast.success("User unblocked successfully");
      setBlockedUsers(
        blockedUsers.filter((user) => user._id !== selectedUser._id)
      );
      setSelectedUser(null);
      closeModal("block");
    } else {
      toast.error(res?.response?.data?.message || res.message);
    }
    setIsUnblocking(false);
  };
  return (
    <section>
      <HeaderFilter getUserList={getBlockedUsers} hasFilter={false} />

      <div
        className={`overflow-x-auto ${
          isLoading ? "h-screen overflow-hidden" : ""
        }`}
      >
        <table className="min-w-full whitespace-nowrap border-0 rounded-md">
          <thead className="bg-[#F9F7FF] text-sm font-medium text-gray-700">
            <tr>
              {[
                { key: "name", label: "User Name" },
                { key: "email", label: "Email Address" },
                { key: "phone", label: "Phone Number" },
                { key: "blockedBy", label: "Block By" },
                { key: "countryCode", label: "Country" },
                { key: "status", label: "Status", sortable: false },
              ].map(({ key, label, sortable = true }) => (
                <th
                  key={key}
                  className={`px-4 py-4 font-medium select-none ${
                    sortable ? "hover:opacity-50 cursor-pointer" : ""
                  }`}
                  onClick={() => sortable && handleSort(key)}
                >
                  {sortable ? (
                    <div className="flex items-center gap-2">
                      {label}
                      {sortConfig.key === key ? (
                        sortConfig.direction === "asc" ? (
                          <FaSortUp />
                        ) : (
                          <FaSortDown />
                        )
                      ) : (
                        <FaSort className="text-gray-300" />
                      )}
                    </div>
                  ) : (
                    <div className="flex items-center gap-2">{label}</div>
                  )}
                </th>
              ))}
              <th className="px-4 py-4 font-medium">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 text-sm">
            {isLoading ? (
              <tr>
                <td colSpan="8" className="text-center p-5 bg-white">
                  Loading...
                </td>
              </tr>
            ) : sortedData.length > 0 ? (
              sortedData.map((user, index) => (
                <tr
                  key={index}
                  className={`bg-white hover:bg-gray-50 ${
                    index === 0 ? "border-t-0" : ""
                  }`}
                >
                  <td className="px-4 py-4">
                    <div className="flex items-center gap-3">
                      <img
                        src={
                          user?.userMedia?.mediaUrl ||
                          user.avtarImage ||
                          profile_Img
                        }
                        alt={user.name}
                        className="w-8 h-8 rounded-full object-cover"
                      />
                      <span>{user.name}</span>
                    </div>
                  </td>
                  <td className="px-4 py-4">{user.email || "-"}</td>
                  <td className="px-4 py-4">{user.phone || "-"}</td>
                  <td className="px-4 py-4">
                    {user?.blockedBy?.name || "N/A"}
                  </td>
                  <td className="px-4 py-4">
                    {user.countryCode
                      ? getCountryFromPhoneCode(user.countryCode)
                      : "-"}
                  </td>

                  <td className="px-4 py-4">
                    <span
                      className={`inline-block px-3 py-1 text-sm rounded-md ${
                        true
                          ? "bg-red-100 text-red-600"
                          : "bg-green-100 text-green-600"
                      }`}
                    >
                      Blocked
                    </span>
                  </td>

                  <td className="px-4 py-4">
                    <button
                      title="Delete"
                      className="bg-[#E6F5EC] rounded-md h-[30px] w-[30px] flex items-center justify-center text-[#F44336] hover:opacity-50"
                      onClick={() => {
                        setSelectedUser(user);
                        openModal("block");
                      }}
                    >
                      <LiaUserLockSolid size={16} className="text-[#06B300]" />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="text-center bg-white py-2">
                  No user found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {!isLoading && totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalItems={totalUsers}
          itemsPerPage={10}
          onPageChange={(page) => {
            getBlockedUsers(page);
          }}
        />
      )}
      {isBlockModalOpen && (
        <div className="modal modal-open">
          <div className="modal-box relative bg-white">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-semibold">Unblock User</h2>

              <MdClose
                onClick={() => {
                  setSelectedUser(null);
                  closeModal("block");
                }}
                size={18}
              />
            </div>

            {/* Image */}
            <div className="flex justify-center mb-4">
              <img
                src={UnBlockVec} // <-- replace with your actual path
                alt="Block warning"
              />
            </div>

            {/* Block confirmation content */}
            <p className="capitalize text-md mb-2 text-center font-bold text-xl">
              Are you sure to unblock user?
            </p>
            <p className="text-sm text-gray-600 mb-8 text-center">
              Do you want to continue and restore the user's access?
            </p>
            <div className="flex justify-center gap-10 mt-4">
              <button
                onClick={() => {
                  setSelectedUser(null);
                  closeModal("block");
                }}
                className="btn btn-outline btn-sm border border-[#EBEBEB] min-w-30 rounded-full min-h-[40px] hover:opacity-50 hover:bg-white hover:shadow-none hover:text-black"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  unblockUser();
                }}
                disabled={isUnblocking}
                className="btn btn-error bg-[var(--primary-color)] btn-sm min-w-30 border-[var(--primary-color)] rounded-full shadow-none text-white p-2.5 min-h-[40px] hover:opacity-50"
              >
                {isUnblocking ? "Unblocking..." : "Yes, Unblock "}
              </button>
            </div>
          </div>
        </div>
      )}

      {isAddUserModalOpen && (
        <div className="modal modal-open">
          <div className="modal-box max-w-3xl bg-white">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-semibold">Add User</h2>
              <MdClose
                className="cursor-pointer"
                onClick={closeAddUserModal}
                size={20}
              />
            </div>
            <form>
              {/* Profile Image Section */}
              <div className="profile-bg max-w-xs flex mx-auto">
                <div className="my-4 w-[130px] h-[130px] mx-auto rounded-4xl border border-dashed border-[#000] overflow-hidden relative">
                  <label
                    htmlFor="imageUpload"
                    className="bg-white cursor-pointer w-full h-full flex items-center justify-center"
                  >
                    {imagePreview ? (
                      <img
                        src={imagePreview}
                        alt="Profile Preview"
                        className="w-full h-full object-cover rounded-4xl"
                      />
                    ) : (
                      <IoAdd className="text-[#7104F8] text-4xl" />
                    )}
                  </label>

                  {imagePreview && (
                    <button
                      type="button"
                      onClick={handleRemoveImage}
                      className="absolute top-1 right-1 bg-[var(--primary-color)] rounded-full p-1 shadow"
                    >
                      <MdClose className="text-white text-xl" />
                    </button>
                  )}

                  <input
                    type="file"
                    id="imageUpload"
                    accept=".jpg,.png"
                    onChange={handleImageChange}
                    className="hidden"
                  />
                </div>
              </div>

              {/* Upload Info Section */}
              <div className="text-center pt-2">
                <p className="text-md text-gray-400 font-normal my-3 w-2/4 text-center flex mx-auto justify-center">
                  Upload a Photo of the User. Click the Submit Button to
                  Continue.
                </p>
              </div>

              {/* User Info Section */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-4">
                {/* User Name Field */}
                <div className="mb-0">
                  <label
                    htmlFor="userName"
                    className="block text-sm text-gray-700 pb-2"
                  >
                    User Name
                  </label>
                  <input
                    type="text"
                    id="userName"
                    className="w-full p-2.5 border border-[#EBEBEB] rounded-md"
                    placeholder="Enter Full Name"
                  />
                </div>

                {/* Phone Number Field */}
                <div className="mb-0">
                  <label
                    htmlFor="phoneNumber"
                    className="block text-sm text-gray-700 pb-2"
                  >
                    Phone Number
                  </label>
                  <div className="flex">
                    <PhoneInput
                      country={"us"}
                      // value={formik.values.phone}
                      // onChange={(phone) => formik.setFieldValue("phone", phone)}
                      containerClass="!w-full !border !rounded-md"
                      inputProps={{
                        placeholder: "Enter Phone Number",
                        name: "phone",
                        autoFocus: false,
                      }}
                      inputClass="!w-full !py-5.5 !pl-14 !pr-4 !rounded-lg !border-none !border-[#EBEBEB] !focus:ring-2 !focus:ring-purple-500 !focus:border-purple-500 !text-base"
                      buttonClass="!bg-transparent !border-none !outline-none !px-3"
                      dropdownClass="!z-50 border-left"
                      inputStyle={{ width: "100%" }}
                    />
                  </div>
                </div>

                {/* Email Field */}
                <div className="mb-0">
                  <label
                    htmlFor="email"
                    className="block text-sm text-gray-700 pb-2"
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="w-full p-2.5 border border-[#EBEBEB] rounded-md"
                    placeholder="Enter Email Address"
                  />
                </div>

                {/* Gender Field */}
                <div className="mb-0">
                  <label
                    htmlFor="gender"
                    className="block text-sm text-gray-700 pb-2"
                  >
                    Gender
                  </label>
                  <select
                    id="gender"
                    className="w-full p-2.5 border border-[#EBEBEB] rounded-md"
                  >
                    <option value="">Select gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                {/* About Field */}
                <div className="mb-4 md:col-span-2">
                  <label
                    htmlFor="about"
                    className="block text-sm text-gray-700 pb-2"
                  >
                    About
                  </label>
                  <select
                    id="about"
                    className="w-full p-2.5 border border-[#EBEBEB] rounded-md"
                  >
                    <option value="">Select</option>
                    <option value="working-remotely">Working Remotely</option>
                    <option value="unemployed">Unemployed</option>
                  </select>
                </div>
              </div>

              {/* Submit Button */}
              <div className="w-full text-sm flex justify-end gap-3 items-center mt-6">
                <button
                  type="button"
                  className="bg-transparent text-black border border-[#ebebe] py-2 px-6 rounded-full hover:opacity-50"
                  onClick={handleNextClick}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="bg-[#7104F8] text-white border border-[#7104F8] py-2 px-8 rounded-full hover:opacity-50"
                  onClick={handleNextClick}
                >
                  Next
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </section>
  );
}
